module.exports = __webpack_public_path__ + "static/scale-model-of-grant-ave-clay-st-mural-in-berkeley-california-a149ac4ece97b5f312b34f295f207a75.png";